import { Component } from '@angular/core';

@Component({
  selector: 'ngshop-nav',
  templateUrl: './nav.component.html',
  styles: [],
})
export class NavComponent {}
